
    var mustache = require('mustache');
    module.exports = function (view, partials) {
      partials = partials || {};
      var src = "<div id=\"coppa\" class=\"input-row input-row-age\">\n  <input type=\"number\" pattern=\"\\d*\" id=\"age\" placeholder=\"{{#t}}How old are you?{{/t}}\" min=\"0\" max=\"130\" value=\"{{ age }}\" {{#required}}required{{/required}} />\n</div>\n"
      return mustache.render(src, view, partials);
    };
  